module.exports = __webpack_public_path__ + "static/media/pdi-image-01.2a225b94.svg";